import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import { formatExpense } from "../shared/FinancialViewHelpers";
import format from "../../../shared/formatters";

const TeamMemberExpense = ({ additionalExpense }) => (
  <div className="transaction-gci-content">
    <Row>
      <Col xs={2}>
        <label>{additionalExpense.name ? additionalExpense.name : ""}</label>
        {additionalExpense.expense_amount && (
          <span>{formatExpense(format.currency(additionalExpense.expense_amount))}</span>
        )}
      </Col>
      <Col xs={5} />
      <Col xs={1} />
      <Col xs={2} className="text-right" />
      <Col xs={2} className="text-right">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label>Subtotal</label>
        <span>{format.currency(additionalExpense.line_total)}</span>
      </Col>
    </Row>
  </div>
);

TeamMemberExpense.propTypes = {
  additionalExpense: PropTypes.shape({
    name: PropTypes.string,
    expense_amount: PropTypes.number,
    line_total: PropTypes.number,
  }).isRequired,
};

export default TeamMemberExpense;
